// @flow
export { default } from './CategoriesTemplate';



// WEBPACK FOOTER //
// ./src/components/categories/CategoriesTemplate/index.js